var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "sidebar-nav",
      class: { "is-pwa": _vm.$isPwa(), "is-ios": _vm.$isIOSDevice() },
    },
    [
      _c(
        "VuePerfectScrollbar",
        {
          staticClass: "scroll-area",
          attrs: { settings: _vm.psSettings },
          on: { "ps-scroll-y": _vm.scrollHandle },
        },
        [
          _c(
            "ul",
            { staticClass: "nav" },
            [
              _vm._l(_vm.navItems, function (item, index) {
                return [
                  item.title
                    ? [
                        _c("SidebarNavTitle", {
                          key: index,
                          attrs: {
                            name: item.name,
                            classes: item.class,
                            wrapper: item.wrapper,
                          },
                        }),
                      ]
                    : item.divider
                    ? [
                        _c("SidebarNavDivider", {
                          key: index,
                          attrs: { classes: item.class },
                        }),
                      ]
                    : item.label
                    ? [
                        _c("SidebarNavLabel", {
                          key: index,
                          attrs: {
                            name: item.name,
                            url: item.url,
                            icon: item.icon,
                            label: item.label,
                            classes: item.class,
                          },
                        }),
                      ]
                    : [
                        item.children
                          ? [
                              _c(
                                "SidebarNavDropdown",
                                {
                                  key: index,
                                  attrs: {
                                    icon: item.icon,
                                    index: index,
                                    url: item.url,
                                    open: item.open,
                                    item: item,
                                  },
                                },
                                [
                                  _vm._l(
                                    item.children,
                                    function (childL1, index1) {
                                      return [
                                        childL1.children
                                          ? [
                                              _c(
                                                "SidebarNavDropdown",
                                                {
                                                  key: index1,
                                                  attrs: {
                                                    icon: childL1.icon,
                                                    index: index1,
                                                    url: childL1.url,
                                                    open: childL1.open,
                                                    item: childL1,
                                                  },
                                                },
                                                _vm._l(
                                                  childL1.children,
                                                  function (childL2, index2) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: index2,
                                                        staticClass: "nav-item",
                                                      },
                                                      [
                                                        _c("SidebarNavLink", {
                                                          attrs: {
                                                            name: childL2.name,
                                                            url: childL2.url,
                                                            icon: childL2.icon,
                                                            badge:
                                                              childL2.badge,
                                                            variant:
                                                              childL2.variant,
                                                            attributes:
                                                              childL2.attributes,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "SidebarNavItem",
                                                {
                                                  key: index1,
                                                  attrs: {
                                                    classes: item.class,
                                                  },
                                                },
                                                [
                                                  _c("SidebarNavLink", {
                                                    attrs: {
                                                      name: childL1.name,
                                                      url: childL1.url,
                                                      icon: childL1.icon,
                                                      badge: childL1.badge,
                                                      variant: childL1.variant,
                                                      attributes:
                                                        childL1.attributes,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          : [
                              _c(
                                "SidebarNavItem",
                                { key: index, attrs: { classes: item.class } },
                                [
                                  _c("SidebarNavLink", {
                                    attrs: {
                                      name: item.name,
                                      url: item.url,
                                      icon: item.icon,
                                      badge: item.badge,
                                      variant: item.variant,
                                      attributes: item.attributes,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                      ],
                ]
              }),
            ],
            2
          ),
          _vm._t("default"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }